import {
    SHOW_USER_MODAL,
    HIDE_USER_MODAL,
    CHANGE_ROLE,
    GET_SANITARY_BOOK,
    UPDATE_SANITARY_BOOK,
} from './userDetails.actionsTypes';

export default function userDetails(state = {}, action) {
	let newState = Object.assign({}, state);
	switch (action.type) {
		case SHOW_USER_MODAL:
			return {
				...newState,
				user: action.user,
				show: true
			};
		case HIDE_USER_MODAL:
			return {
				...newState,
				show: false,
				changedRole: null
			};
		case CHANGE_ROLE:
			return {
				...newState,
				changedRole: action.changedRole
			};
		case GET_SANITARY_BOOK:
			return {
				...newState,
				sanitaryBook: action.sanitaryBook
			};
		case UPDATE_SANITARY_BOOK:
			return {
				...newState,
				sanitaryBook: action.sanitaryBook,
				user: newState.user
					? { ...newState.user, sanitaryBook: action.sanitaryBook }
					: newState.user
			};
		default:
			return newState;
	}
}